/**
 * @generated SignedSource<<3b6394382e6030aff89f4c82000b76aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBankAccountListWrapper_transaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountList_transaction">;
  readonly " $fragmentType": "CheckoutBankAccountListWrapper_transaction";
};
export type CheckoutBankAccountListWrapper_transaction$key = {
  readonly " $data"?: CheckoutBankAccountListWrapper_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountListWrapper_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBankAccountListWrapper_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccountList_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "c95973f8cf1d2599f0b0902470709594";

export default node;
